import {
	DateTimePicker,
	LocalizationProvider,
	MobileDateTimePicker,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React from 'react';

export default function DateTime(props) {
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<MobileDateTimePicker {...props} />
		</LocalizationProvider>
	);
}
